import React from 'react';
import {Helmet} from 'react-helmet-async';
import {company} from '../data/company';

const BASE='https://plazatur.com';
// Resolve any cover/OG image to a valid absolute URL.
// - uploaded media (/api/media/..) -> served from production domain
// - external absolute (e.g. unsplash) -> kept as-is
// - relative path -> prefixed with production base
const absImg=(u)=>{
  if(!u) return BASE+'/assets/plaza-mark.png';
  const i=u.indexOf('/api/media/');
  if(i>=0) return BASE+u.slice(i);
  if(/^https?:\/\//.test(u)) return u;
  return BASE+(u.startsWith('/')?u:'/'+u);
};
export default function Seo({title,description,path='/',image='/assets/plaza-mark.png',type='website',jsonLd,noindex=false}){
  const url=BASE+path;
  const img=absImg(image);
  const t=title||'Plaza Turizm | Kurumsal Seyahat Yönetimi';
  const d=description||'1992\'den beri uçuş, otel, VIP transfer, araç kiralama, vize ve kurumsal seyahat yönetimi çözümleri.';
  return <Helmet>
    <title>{t}</title>
    <meta name="description" content={d}/>
    {noindex&&<meta name="robots" content="noindex, nofollow"/>}
    <link rel="canonical" href={url}/>
    <meta property="og:type" content={type}/>
    <meta property="og:title" content={t}/>
    <meta property="og:description" content={d}/>
    <meta property="og:url" content={url}/>
    <meta property="og:image" content={img}/>
    <meta property="og:site_name" content={company.name}/>
    <meta name="twitter:card" content="summary_large_image"/>
    <meta name="twitter:title" content={t}/>
    <meta name="twitter:description" content={d}/>
    <meta name="twitter:image" content={img}/>
    <html lang="tr"/>
    {jsonLd&&<script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
  </Helmet>;
}

export function orgJsonLd(){
  return {
    '@context':'https://schema.org','@type':'Organization',name:company.name,url:BASE,
    logo:BASE+'/assets/plaza-logo.png',
    foundingDate:'1992',
    telephone:company.phone,email:company.email,
    address:{'@type':'PostalAddress',streetAddress:company.address.line,addressLocality:'Bursa',postalCode:'16080',addressCountry:'TR'},
    slogan:company.legalTagline
  };
}
export function breadcrumbJsonLd(items){
  return {'@context':'https://schema.org','@type':'BreadcrumbList',itemListElement:items.map((it,i)=>({'@type':'ListItem',position:i+1,name:it.name,item:BASE+it.path}))};
}
